export default __webpack_public_path__ + "static/media/pricing_new_csv.ff2753d4.csv";